(function(global) { // eslint-disable-line
    var pluginName = 'PlacesAutocomplete';

    var config = {
        api_key: 'AIzaSyBf09BGTnFCZeZSxZumyRi1zcHj_pczTG8'
    }

    // Constructor
    function PlacesAutocomplete(selector, options) {
        // Merge defaults with user's settings
        this.config = global.methods.objectAssign(config, options);

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        this.api_key = this.config.api_key;
        this.input = document.getElementById("autocomplete");
        this.options = {
            types: ['geocode']
        };
        this.autocomplete;
        this.locationSearchParameters = {};
        this.componentForm = {
            street_number: 'short_name',
            route: 'long_name',
            locality: 'short_name',
            administrative_area_level_1: 'short_name',
            country: 'short_name',
            postal_code: 'short_name'
        };

        this.init();
    }

    PlacesAutocomplete.prototype.init = function init() {
        window.autocompleteInstance = function() {
            window.PlacesAutocomplete.initPlacesAutocomplete();
        };

        var placesAutocompleteScript = document.getElementById('places_autocomplete_script');
        if(!placesAutocompleteScript) {
            var script = document.createElement('script');
            var firstScriptTag = document.getElementsByTagName('script')[0];
            script.src = 'https://maps.googleapis.com/maps/api/js?key='+ this.api_key +'&libraries=places&callback=autocompleteInstance';
            script.id = 'places_autocomplete_script';
            script.async = true;
            firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
        }
    };

    PlacesAutocomplete.prototype.initPlacesAutocomplete = function initPlacesAutocomplete() {
        this.autocomplete = new window.google.maps.places.Autocomplete(this.input, this.options);
        this.autocomplete.addListener('place_changed', this.getLocationParameters.bind(this));
        this.input.addEventListener('focus', this.geolocate.bind(this));

        // enter to select
        window.google.maps.event.addDomListener(this.input, 'keydown', function(e) {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
        });
    };

    PlacesAutocomplete.prototype.getLocationParameters = function getLocationParameters() {
        var place = this.autocomplete.getPlace();
        var locationSearchParameters = this.locationSearchParameters;
        var componentForm = this.componentForm;

        if (!place.geometry) {
            console.warn('Autocomplete\'s returned place contains no geometry');
            // this.displayValidation({
            //     'type': 'error',
            //     'message': 'Une erreur est survenue'
            // });
            return;
        }

        locationSearchParameters.geocode = {
            lat: place.geometry.location.lat,
            lon: place.geometry.location.lng
        };

        for (var i = 0; i < place.address_components.length; i++) {
            var placeAddress = place.address_components[i],
                componentType = placeAddress.types[0],
                valueType = componentForm[componentType],
                value = placeAddress[valueType];

            if (valueType) {
                switch (componentType) {
                case 'locality':
                    locationSearchParameters.city = value;
                    break;
                case 'country':
                    locationSearchParameters.country = value;
                    break;
                case 'administrative_area_level_1':
                    locationSearchParameters.state = value;
                    break;
                case 'postal_code':
                    locationSearchParameters.zipcode = value;
                    break;
                default:
                }
            }
        }

        this.locationSearchParameters = locationSearchParameters; // global ref
        // console.log(this.locationSearchParameters);
        this.display(place, componentForm);
    };

    PlacesAutocomplete.prototype.display = function display(place, componentForm) {
        for (var component in componentForm) {
            this.selector.querySelector('[data-type="'+component+'"]').value = '';
            this.selector.querySelector('[data-type="'+component+'"]').disabled = false;
        }

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];
            if (componentForm[addressType]) {
                var val = place.address_components[i][componentForm[addressType]];
                this.selector.querySelector('[data-type="'+addressType+'"]').value = val;
            }
        }
    };

    PlacesAutocomplete.prototype.displayValidation = function displayValidation(arg) {
        var wrapper = this.input.parentNode;
        if (arg.type === 'error') {
            if (!wrapper.querySelector('.help-block')) {
                wrapper.classList.add('has-error');
                var errorNode = document.createElement('div');
                errorNode.className = 'help-block';
                errorNode.innerHTML = arg.message;
                wrapper.appendChild(errorNode);
            }
        }
    };

    PlacesAutocomplete.prototype.geolocate = function geolocate() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                var circle = new window.google.maps.Circle({center: geolocation, radius: position.coords.accuracy});
                this.autocomplete.setBounds(circle.getBounds());
            });
        }
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports)
        module.exports = PlacesAutocomplete; // Export to Browser
    else
        global[pluginName] = PlacesAutocomplete; // eslint-disable-line

    // app instantiation
    $('body').on('app.init', function(ev) {
        var $container = $(ev.container);

        if ($container.find('[places-autocomplete]').length) {
            var all = $container.find('[places-autocomplete]');
            var index = -1;
            while (all[++index])
                window.PlacesAutocomplete = new PlacesAutocomplete(all[index]);
        }
    });

}(window.groots));
